import { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const AlertIconOwner: React.FC<IconSvgProps> = (props) => (
  <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M24.6113 7.58543C24.8032 7.24952 25.2876 7.24952 25.4795 7.58543L42.0332 36.5543C42.2236 36.8876 41.983 37.3024 41.5991 37.3024H8.49177C8.10786 37.3024 7.86717 36.8876 8.05765 36.5543L24.6113 7.58543Z"
      fill="#6450F7"
      stroke="#D1D1D1"
      strokeWidth="3"
    />
    <mask
      id="mask0_13555_130131"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="-6"
      y="-7"
      width="37"
      height="43"
    >
      <ellipse cx="12.4361" cy="14.0823" rx="17.9365" ry="20.9185" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_13555_130131)">
      <path
        d="M24.6113 7.58543C24.8032 7.24952 25.2876 7.24952 25.4795 7.58543L42.0332 36.5543C42.2236 36.8876 41.983 37.3024 41.5991 37.3024H8.49177C8.10786 37.3024 7.86717 36.8876 8.05765 36.5543L24.6113 7.58543Z"
        fill="#8373F9"
        stroke="white"
        strokeWidth="3"
      />
    </g>
    <rect
      x="24.1238"
      y="28.2567"
      width="12.3077"
      height="1.84328"
      rx="0.921638"
      transform="rotate(-90 24.1238 28.2567)"
      fill="white"
    />
    <rect
      x="24.1238"
      y="34.2804"
      width="3"
      height="1.84328"
      rx="0.921638"
      transform="rotate(-90 24.1238 34.2804)"
      fill="white"
    />
  </svg>
)
